// eslint-disable-next-line import/prefer-default-export
export const Fieldset = {
  Rotate: 'rotation',
  Position: 'position',
};
